import { createSlice } from '@reduxjs/toolkit'

export const ProjectRequestSourceDocumentSlice = createSlice({
  name: 'project_request_source_material',
  initialState: {
    value: '',
  },
  reducers: {
    projectRequestSourceDocument: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { projectRequestSourceDocument } = ProjectRequestSourceDocumentSlice.actions

export default ProjectRequestSourceDocumentSlice.reducer